// 组件
import SortItem from "./sortItem";
// 方法
import classNames from "classnames";
import { SortableContainer } from "@yonboo/react-sortable-hoc";
// 常量
import { SortListProps } from "../interface";

const SortList = SortableContainer((props: SortListProps) => {
  const { sortAxis, className, children, } = props;

  const classes = classNames('yb-sort', className, {
    'yb-sort-x': sortAxis === 'x',
    'yb-sort-y': sortAxis === 'y',
    'yb-sort-xy': sortAxis === 'xy',
  });
  return (
    <div className={classes}>
      {children}
    </div>
  );
});

export default SortList;
